export default "__VITE_ASSET__c9684e20__"